import { css, keyframes } from 'emotion';

const slideIn = keyframes`
  from {
    bottom: -222px;
  } to {
    bottom: 0vh;
  }
`;

const slideOut = keyframes`
  from {
    bottom: 0vh;
  } to {
    bottom: -222px;
  }
`;

export const animateSliderBody = (theme, closeSlider) => css`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 222px;
  width: 100vw;
  background: ${theme.color.dark.uranus};
  z-index: 4;
  ${closeSlider
    ? `
    animation: ${slideOut} 0.3s ease-out;`
    : `
    animation: ${slideIn} 0.3s ease-in;`}
`;

export const sliderOverlay = theme => css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  background: ${theme.color.dark.uranus};
  opacity: 0.8;
  z-index: 3;
`;
